export default "__VITE_ASSET__oxL4osWW__"